// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';


import BitUtils from '../../utils/BitUtils';

// -- views

export default class BitfieldChooser extends Component {

  static defaultProps = {
    mask: 0,
    multiple: true,
    readOnly: false,
  };

  static propTypes = {
    mask: PropTypes.number,
    multiple: PropTypes.bool,

    /**
    * @type array { label: string, value: number }
    */
    options: PropTypes.array.isRequired,

    // param: String, the chosen POS
    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool
  };

  onChange = (mask) => {
    if (_.isNull(mask)) {
      this.props.onChange(null);
    } else {
      this.props.onChange(mask)
    }
  };

  onToggleItem = (item: Object) => {
    const mask = this.props.mask;
    const value = item.value;

    if (this.props.multiple) {
      this.onChange(BitUtils.toggle(mask, value));
    } else {
      this.onChange(value)
    }
  };

  //
  //
  //

  renderSelected = () => (
    <i className={`fa fa-check-${this.props.multiple ? 'square' : 'circle'}-o`} />
  )

  renderUnselected = () => (
    <i className={`fa fa-${this.props.multiple ? 'square' : 'circle'}-o`} />
  )

  renderItem(item: Object) {
    const bitIsSet =
      this.props.multiple
        ? BitUtils.isSet(this.props.mask, item.value)
        : this.props.mask === item.value

    return (
      <div
        key={item.value}
        className="bitfield_chooser__item"
        onClick={() => { !this.props.readOnly && this.onToggleItem(item); }}
      >
        {bitIsSet &&
          this.renderSelected()
        }
        {!bitIsSet &&
          this.renderUnselected()
        }
        &nbsp;&nbsp;
        {item.label}
      </div>
    );
  }

  render() {
    return (
      <div className="bitfield_chooser disable-user-select">
        {this.props.options.map((item: Object) => {
          return this.renderItem(item);
        })}
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/components/form/BitfieldChooser.js